import React, { useState, useEffect } from "react"
import {
  CardBody,
  CardHeader,
  Container,
  Row,
  Col,
  Card,
  CardTitle,
  Form,
  Label,
  Input,
  Button,
  Table,
  Modal,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import ReactPaginate from "react-paginate"
import axios from "axios"
import { URLS } from "../../Url"
import { useHistory } from "react-router-dom"

const Plans = () => {
  const [show, setshow] = useState(false)

  const [modal_small, setmodal_small] = useState(false)
  const [Plans, setPlans] = useState([])
  const [form, setform] = useState([])
  const [form1, setform1] = useState([])

  const [Files, setFiles] = useState("")
  const [Files1, setFiles1] = useState("")

  const changeHandler = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }
  const changeHandler1 = e => {
    const file = e.target.files
    var ext = file[0].name.split(".").pop()
    var type = ext
    if (type == "jpg" || type == "jpeg" || type == "png") {
      setFiles1(e.target.files)
    } else {
      e.target.value = null
      toast("File format not supported. Please choose JPG, JPEG, or PNG.")
    }
  }

  function tog_small() {
    setmodal_small(!modal_small)
  }

  const handleChange = e => {
    let myUser = { ...form }
    myUser[e.target.name] = e.target.value
    setform(myUser)
  }
  const handleChange1 = e => {
    let myUser = { ...form1 }
    myUser[e.target.name] = e.target.value
    setform1(myUser)
  }

  useEffect(() => {
    GetAllPlans()
  }, [])

  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)
  var datas = data.token

  const [listPerPage] = useState(5)
  const [pageNumber, setPageNumber] = useState(0)

  const pagesVisited = pageNumber * listPerPage
  const lists = Plans.slice(pagesVisited, pagesVisited + listPerPage)
  const pageCount = Math.ceil(Plans.length / listPerPage)
  const changePage = ({ selected }) => {
    setPageNumber(selected)
  }

  const handleSubmit = e => {
    e.preventDefault()
    AddPlans()
  }

  const AddPlans = () => {
    var token = datas

    const dataArray = new FormData()
    dataArray.append("name", form.name)
    dataArray.append("validity", form.validity)
    dataArray.append("price", form.price)
    dataArray.append("offerprice", form.offerprice)
    dataArray.append("description", form.description)
    dataArray.append("benfits", form.benfits)
    dataArray.append("discount", form.discount)
    dataArray.append("type", form.type)

    for (let i = 0; i < Files.length; i++) {
      dataArray.append("image", Files[i])
    }

    axios
      .post(URLS.AddUserPlans, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllPlans()
            clearForm()
            setshow(false)
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const EditPlans = () => {
    var token = datas
    var formid = form1._id
    const dataArray = new FormData()
    dataArray.append("name", form1.name)
    dataArray.append("validity", form1.validity)
    dataArray.append("price", form1.price)
    dataArray.append("offerprice", form1.offerprice)
    dataArray.append("description", form1.description)
    dataArray.append("benfits", form1.benfits)
    dataArray.append("discount", form1.discount)

    for (let i = 0; i < Files1.length; i++) {
      dataArray.append("image", Files1[i])
    }
    axios
      .put(URLS.UpdateUserPlans + formid, dataArray, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllPlans()
            setmodal_small(false)
            clearForm1()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const DeletePlans = data => {
    var token = datas
    var remid = data._id
    axios
      .delete(URLS.InActiveUserPlans + remid, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then(
        res => {
          if (res.status === 200) {
            toast(res.data.message)
            GetAllPlans()
          }
        },
        error => {
          if (error.response && error.response.status === 400) {
            toast(error.response.data.message)
          }
        }
      )
  }

  const manageDelete = data => {
    const confirmBox = window.confirm("Do you really want to Delete?")
    if (confirmBox === true) {
      DeletePlans(data)
    }
  }

  const handleSubmit1 = e => {
    e.preventDefault()
    EditPlans()
  }

  const GetAllPlans = () => {
    var token = datas
    const dataArray = {}
    axios
      .post(
        URLS.GetUserPlans,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setPlans(res.data.data)
        setIsLoading(false)
      })
  }
  const clearForm1 = () => {
    setFiles1({
      image: "",
    })
  }
  const clearForm = () => {
    setform({
      name: "",
      validity: "",
      price: "",
      offerprice: "",
      description: "",
      benfits: "",
      discount: "",
      type: "",
    })
    setFiles({
      image: "",
    })
  }

  const getpopup = data => {
    setform1(data)
    tog_small()
  }

  const [search, setsearch] = useState([])

  const searchAll = e => {
    let myUser = { ...search }
    myUser[e.target.name] = e.target.value
    setsearch(myUser)

    var token = datas
    axios
      .post(
        URLS.GetUserPlansSearch + `${e.target.value}`,
        {},

        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then(res => {
        setPlans(res.data.data)
      })
  }
  var gets = localStorage.getItem("authUser")
  var data = JSON.parse(gets)

  const history = useHistory()

  const Actinid1 = data => {
    sessionStorage.setItem("UserId", data._id)
    history.push("/ViewUserSubsriptionList")
  }

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Home " breadcrumbItem="User Plans" />
          <Row>
            {show == true ? (
              <Col md={12}>
                <Card>
                  <CardHeader className="bg-white">
                    <CardTitle>Add User Plan</CardTitle>
                  </CardHeader>
                  <CardBody>
                    <Form
                      onSubmit={e => {
                        handleSubmit(e)
                      }}
                    >
                      <Row>
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Plan Name <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder="Enter Name"
                              required
                              name="name"
                              value={form1.name}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label> Validity</Label>{" "}
                            <span className="text-danger">*</span>
                            <select
                              value={form.validity}
                              name="validity"
                              required
                              onChange={e => {
                                handleChange(e)
                              }}
                              className="form-select"
                            >
                              <option value="">Select</option>
                              <option value="1Month">1 Month</option>
                              <option value="2 Months">2 Months</option>
                            </select>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label> Type</Label>{" "}
                            <span className="text-danger">*</span>
                            <select
                              value={form.type}
                              name="type"
                              required
                              onChange={e => {
                                handleChange(e)
                              }}
                              className="form-select"
                            >
                              <option value="">Select</option>
                              <option value="0">Classic</option>
                            </select>
                          </div>
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Plan Price <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder="Enter Plan Price "
                              required
                              name="price"
                              value={form.price}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>{" "}
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Offer Price <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder="Enter  Offer Price "
                              required
                              name="offerprice"
                              value={form.offerprice}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>{" "}
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Discount <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="text"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              placeholder="Enter Discount"
                              required
                              name="discount"
                              value={form.discount}
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>{" "}
                        </Col>
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Image <span className="text-danger">*</span>
                            </Label>
                            <Input
                              type="file"
                              className="form-control"
                              id="basicpill-firstname-input1"
                              required
                              name="image"
                              value={Files.image}
                              onChange={changeHandler}
                            />
                          </div>{" "}
                        </Col>
                        {/* <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Description <span className="text-danger">*</span>
                            </Label>
                            <textarea
                              type="text"
                              rows="1"
                              className="form-control "
                              id="basicpill-firstname-input1"
                              placeholder="Enter Description"
                              required
                              value={form.description}
                              name="description"
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>{" "}
                        </Col> */}
                        <Col md="6">
                          <div className="mb-3">
                            <Label for="basicpill-firstname-input1">
                              Benfits <span className="text-danger">*</span>
                            </Label>
                            <textarea
                              type="text"
                              rows="3"
                              className="form-control "
                              id="basicpill-firstname-input1"
                              placeholder="Enter Benfits"
                              required
                              value={form.benfits}
                              name="benfits"
                              onChange={e => {
                                handleChange(e)
                              }}
                            />
                          </div>{" "}
                        </Col>
                      </Row>
                      <Row>
                        <Col md="12">
                          <div style={{ float: "right" }}>
                            <Button color="primary" type="submit">
                              Submit <i className="fas fa-check-circle"></i>
                            </Button>
                          </div>
                        </Col>
                      </Row>
                    </Form>
                  </CardBody>
                </Card>
              </Col>
            ) : (
              ""
            )}
          </Row>
          <Row>
            <Col md={12}>
              <Card>
                <CardBody>
                  <div>
                    <Row>
                      <Col>
                        <Button
                          onClick={() => {
                            setshow(!show)
                          }}
                          color="primary"
                        >
                          Add User Plan
                          <i className="bx bx-user-plus"></i>
                        </Button>
                      </Col>
                      <Col>
                        <div style={{ float: "right" }}>
                          <Input
                            type="text"
                            className="form-control"
                            placeholder="Search.."
                            value={search.search}
                            onChange={searchAll}
                            name="search"
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="table-responsive">
                      <Table className="table table-bordered mb-4 mt-5">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Image</th>
                            <th>Plan Name</th>
                            <th>Plan Validity</th>
                            <th>Plan Type</th>
                            <th>Plan Price </th>
                            <th>Offer Price</th>
                            <th>Discount </th>
                            <th>Benfits </th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {lists.map((data, key) => (
                            <tr key={key}>
                              <th>{(pageNumber - 1) * 5 + key + 6}</th>
                              <td>
                                <img
                                  style={{ width: "100px" }}
                                  src={URLS.Base + data.image}
                                />
                              </td>
                              <td>{data.name}</td>
                              <td>{data.validity}</td>
                              <td>{data.type}</td>
                              <td>{data.price}</td>
                              <td>{data.offerprice}</td>
                              <td>{data.benfits}</td>
                              <td>{data.discount}</td>
                              <td>
                                <Button
                                  onClick={() => {
                                    getpopup(data)
                                  }}
                                  className="mr-2"
                                  style={{
                                    padding: "6px",
                                    margin: "3px",
                                  }}
                                  color="success"
                                  outline
                                >
                                  <i className="bx bx-edit "></i>
                                </Button>
                                <Button
                                  onClick={() => {
                                    Actinid1(data)
                                  }}
                                  size="sm"
                                  className="m-1"
                                  outline
                                  color="info"
                                >
                                  <i
                                    style={{ fontSize: " 14px" }}
                                    className="fas fa-eye"
                                  ></i>
                                </Button>
                                <Button
                                  onClick={() => {
                                    manageDelete(data)
                                  }}
                                  style={{
                                    padding: "6px",
                                    margin: "3px",
                                  }}
                                  color="danger"
                                  outline
                                >
                                  <i className="bx bx-trash"></i>
                                </Button>{" "}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      <div className="mt-3" style={{ float: "right" }}>
                        <ReactPaginate
                          previousLabel={"Previous"}
                          nextLabel={"Next"}
                          pageCount={pageCount}
                          onPageChange={changePage}
                          containerClassName={"pagination"}
                          previousLinkClassName={"previousBttn"}
                          nextLinkClassName={"nextBttn"}
                          disabledClassName={"disabled"}
                          activeClassName={"active"}
                          total={lists.length}
                        />
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
          <Modal
            size="lg"
            isOpen={modal_small}
            toggle={() => {
              tog_small()
            }}
            centered
          >
            <div className="modal-header">
              <h5 className="modal-title mt-0" id="mySmallModalLabel">
                Edit User Plan
              </h5>
              <button
                onClick={() => {
                  setmodal_small(false)
                }}
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div className="modal-body">
              <Form
                onSubmit={e => {
                  handleSubmit1(e)
                }}
              >
                <Row>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Plan Name <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Name"
                        required
                        name="name"
                        value={form1.name}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label> Validity</Label>{" "}
                      <span className="text-danger">*</span>
                      <select
                        value={form1.validity}
                        name="validity"
                        required
                        onChange={e => {
                          handleChange1(e)
                        }}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="1Month">1 Month</option>
                        <option value="2 Months">2 Months</option>
                      </select>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label> Type</Label>{" "}
                      <span className="text-danger">*</span>
                      <select
                        value={form1.type}
                        name="type"
                        required
                        onChange={e => {
                          handleChange1(e)
                        }}
                        className="form-select"
                      >
                        <option value="">Select</option>
                        <option value="Classic">Classic</option>
                      </select>
                    </div>
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Plan Price <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Plan Price "
                        required
                        name="price"
                        value={form1.price}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>{" "}
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Offer Price <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter  Offer Price "
                        required
                        name="offerprice"
                        value={form1.offerprice}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>{" "}
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Discount <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="text"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        placeholder="Enter Discount"
                        required
                        name="discount"
                        value={form1.discount}
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>{" "}
                  </Col>
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Image <span className="text-danger">*</span>
                      </Label>
                      <Input
                        type="file"
                        className="form-control"
                        id="basicpill-firstname-input1"
                        required
                        name="image"
                        value={Files.image}
                        onChange={changeHandler1}
                      />
                    </div>{" "}
                  </Col>
                  {/* <Col md="6">
                  <div className="mb-3">
                    <Label for="basicpill-firstname-input1">
                      Description <span className="text-danger">*</span>
                    </Label>
                    <textarea
                      type="text"
                      rows="1"
                      className="form-control "
                      id="basicpill-firstname-input1"
                      placeholder="Enter Description"
                      required
                      value={form1.description}
                      name="description"
                      onChange={e => {
                        handleChange1(e)
                      }}
                    />
                  </div>{" "}
                </Col> */}
                  <Col md="6">
                    <div className="mb-3">
                      <Label for="basicpill-firstname-input1">
                        Benfits <span className="text-danger">*</span>
                      </Label>
                      <textarea
                        type="text"
                        rows="3"
                        className="form-control "
                        id="basicpill-firstname-input1"
                        placeholder="Enter Benfits"
                        required
                        value={form1.benfits}
                        name="benfits"
                        onChange={e => {
                          handleChange1(e)
                        }}
                      />
                    </div>{" "}
                  </Col>
                </Row>

                <div style={{ float: "right" }}>
                  <Button color="primary" type="submit">
                    Submit <i className="fas fa-check-circle"></i>
                  </Button>
                </div>
              </Form>
            </div>
          </Modal>
          <ToastContainer />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default Plans
